import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=593da48a&"
import script from "./PostEdit.vue?vue&type=script&lang=js&"
export * from "./PostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593da48a')) {
      api.createRecord('593da48a', component.options)
    } else {
      api.reload('593da48a', component.options)
    }
    module.hot.accept("./PostEdit.vue?vue&type=template&id=593da48a&", function () {
      api.rerender('593da48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/post/PostEdit.vue"
export default component.exports